import gql from 'graphql-tag';

export const all = gql`{
    ports {
        id
        name
        
        country {
            id
            name
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/port.js